import { useRef, useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import AnnouncementTable from './components/AnnouncementTable';
import AnnouncementForm from './components/AnnouncementForm';
import AnnouncementFilters from './components/AnnouncementFilters';
import useAnnouncementData from './hooks/useAnnouncementData';
import useAnnouncementForm from './hooks/useAnnouncementForm';
import { useLanguage } from '../../../contexts/LanguageContext';
import { useGetAnnouncementDocumentsByIdQuery } from '../../../api';

const AnnouncementPage = () => {
    const { th } = useLanguage();

    const {
        announcements,
        loading,
        totalCount,
        pagination,
        filters,
        isCreating,
        isUpdating,
        isDeleting,
        filterFields,
        customFilterTypes,
        customFilterOptions,
        handleDelete,
        saveAnnouncement,
        handleSearch,
        handleResetFilters,
        handleApplyFilters,
        onPageChange
    } = useAnnouncementData();

    const formProps = useAnnouncementForm(saveAnnouncement);
    const { handleAddNew, handleEdit, handleSafeDownload } = formProps;

    const [downloadId, setDownloadId] = useState(null);
    const [resolveDownload, setResolveDownload] = useState(null);

  const { data: docsRaw, isFetching: docsFetching } =
    useGetAnnouncementDocumentsByIdQuery(downloadId, { skip: !downloadId });

  const normalizeDocs = (raw) =>
    Array.isArray(raw) ? raw : (raw?.data ?? raw?.items ?? []);

  const getFileKey = (d) =>
    d?.fileKey ?? d?.FileKey ?? d?.key ?? d?.Key ?? d?.documentKey ?? d?.DocumentKey ?? d?.storageKey ?? d?.StorageKey ?? null;

    useEffect(() => {
        if (!downloadId || docsFetching) return;
        (async () => {
            const docs = normalizeDocs(docsRaw);

            //Sıralı İndirme

            for (const doc of docs) {
                const key = getFileKey(doc);
                if (key) {
                    await handleSafeDownload({ ...doc, fileKey: key });
                }
            }

            setDownloadId(null);
            resolveDownload?.();
            setResolveDownload(null);
        })();
    }, [downloadId, docsFetching, docsRaw]);

    const onDownload = (row) => {
        const id = Number(row?.id ?? row?.Id);
        if (!Number.isFinite(id)) return Promise.resolve();
        return new Promise((resolve) => {
            setResolveDownload(() => resolve);
            setDownloadId(id);
        });
    };

    const columnsRef = useRef(null);

    return (
        <div className="card">
            {(isCreating || isUpdating || isDeleting) && (
                <div className="card-overlay">
                    <div className="loading-indicator">
                        <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }} />
                    </div>
                </div>
            )}

            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('announcement.title')}</h1>
                <Button label={th('announcement.newTitle')} icon="pi pi-plus" onClick={handleAddNew} />
            </div>

            <AnnouncementForm {...formProps} />

            <div className="mb-2">
                <AnnouncementFilters
                    filterFields={filterFields}
                    columns={columnsRef.current}
                    customFilterTypes={customFilterTypes}
                    customFilterOptions={customFilterOptions}
                    handleSearch={handleSearch}
                    handleApplyFilters={handleApplyFilters}
                    handleResetFilters={handleResetFilters}
                />
            </div>

            <AnnouncementTable
                onDownload={onDownload}
                announcement={announcements}
                loading={loading || docsFetching}
                totalCount={totalCount}
                pagination={pagination}
                onPageChange={onPageChange}
                filters={filters}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
            />
        </div>
    );
};

export default AnnouncementPage;